<div class="contact-manager">
    <div class="main-wrapper-section">
        <div class="common-header contract-header">
            <div class="text-left width-33 float-left"><h3>{{primaryContactName}}</h3></div>
            <div class="text-right width-66 float-right">
                <div class="button-group">
                    <!--<button (click)="saveSignature()" [hidden]="!isSignAccept || contractStatusId != 5" class="primary-btn">Accept</button>-->
                    <button [hidden]="user?.slurpyUserId == 0 || contractId == 0 || contractStatusId < 5" (click)="archive()" class="primary-btn margin-left15">Archive PDFs</button>
                    <button [hidden]="contractId == 0" (click)="openLog('contract')" class="primary-btn margin-left15">Contract Log</button>
                    <button *ngIf="contractId > 0 && (user?.slurpyUserId > 0 || api_log_visible)" (click)="openLog('activity')" class="primary-btn margin-left15">API Log</button>
                    <button [hidden]="!contractEdit" class="primary-btn margin-left15" (click)="saveContract(null)">Save Contract <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                    <button [hidden]="!contractEdit" class="cancel-btn margin-left15" (click)="cancel()">Cancel</button>
                    <button [hidden]="contractId <= 0 || contractEdit || disableSaveContract" class="primary-btn margin-left15" (click)="EditContract()">Edit Contract</button>
                    <!--<button [hidden]="contractId <= 0 || contractEdit || disableSaveContract" class="primary-btn margin-left15" (click)="processSubscriptions()">Subscriptions</button>-->
                    <!--<button [hidden]="contractId <= 0 || contractEdit || disableSaveContract" class="primary-btn margin-left15" (click)="processEmails()">Emails</button>-->
                    <button [hidden]="contractId <= 0 || !contractEdit" class="primary-btn-delete margin-left15" (click)="confirmDelete()">Delete</button>
                </div>
            </div>
        </div>
        <div class="card-section">
            <div class="card-panel">
                <div>
                    <div class="row">
                        <div class="col-lg-3 col-sm-12">
                            <h5 class="float-left">Contract Details</h5>
                            <div class="custom-control custom-switch float-left" style="padding-left: 50px; margin-top: 2px;" [hidden]="user?.slurpyUserId == 0 || contractId == 0 || !contractEdit">
                                <input type="checkbox" class="custom-control-input" id="admin_override" [(ngModel)]="admin_override" [ngModelOptions]="{standalone: true}">
                                <label class="custom-control-label custom-control-label-disabled" for="admin_override">Admin Override</label>
                            </div>
                        </div>
                        <div class="col-lg-9 col-sm-12">
                            <div class="flex-display">
                                <button type="button" [disabled]="isDownloadedDL" [hidden]="isShowDLDownload()" (click)="downloadDL()" class="primary-btn margin-left15">
                                    Download Driver's License&nbsp;
                                    <i class="fa fa-spinner fa-spin" [hidden]="!isDownloadedDL"></i>
                                </button>
                                <button type="button" [disabled]="isDownloaded" [hidden]="contractStatusId < 5" (click)="downloadContract()" class="primary-btn margin-left15">
                                    Download Contract&nbsp;
                                    <i class="fa fa-spinner fa-spin" [hidden]="!isDownloaded"></i>
                                </button>
                                <button type="button" [disabled]="isReview" [hidden]="!isShowReview" (click)="review();" class="primary-btn margin-left15">
                                    Reviewed&nbsp;<i class="fa fa-spinner fa-spin" [hidden]="!isReview"></i>
                                </button>
                                <div [hidden]="user?.slurpyUserId == 0 || contractId == 0 || !admin_override || !contractEdit" style="margin-top: -5px; height: 29px; padding-left: 10px;">
                                    <kendo-combobox class="form-control min-width200" [data]="contractStatuses"
                                                    [valuePrimitive]="true"
                                                    textField="status"
                                                    [kendoDropDownFilter]="filterSettings"
                                                    [clearButton]="false"
                                                    [filterable]="true"
                                                    [(ngModel)]="contractStatusIdAdmin"
                                                    valueField="statusID">
                                    </kendo-combobox>
                                </div>
                                <div class="min-width260" [hidden]="!contractEdit">
                                    <label style="margin-top: 8px; margin-left: 7px;">Action</label>
                                    <kendo-combobox class="form-control max-width200 float-right" [data]="actionTypes"
                                                    [valuePrimitive]="true"
                                                    textField="status"
                                                    [kendoDropDownFilter]="filterSettings"
                                                    [clearButton]="false"
                                                    [filterable]="true"
                                                    (valueChange)="typeChange($event)"
                                                    [(ngModel)]="actionTypeID"
                                                    valueField="statusID">
                                    </kendo-combobox>
                                </div>
                                <i class="fa fa-refresh margin-left15" title="Refresh Contract" [ngClass]="showSpinner ? 'fa-spin' : ''" (click)="refreshContract(true)" style="font-size:20px; cursor:pointer"></i>
                                <h5 class="mb-0" style="margin-left:5px;"> Status: <span [ngClass]="contractStatusId == 5 || contractStatusId == 6 ? 'active-product' : 'not-active-product'">{{ contractStatusId == 0 ? 'None' : contractStatusId == 1 ? 'Configured' : contractStatusId == 2 ? 'In Progress' : contractStatusId == 3 ? 'Member Signed' :contractStatusId == 4 ? 'On Hold Review' : contractStatusId == 5 ? 'Contract Waiting Countersign' : contractStatusId == 6 ? 'Active' : 'In-Active' }}</span></h5>

                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="contract-pad" [ngClass]="!isSignVisible ? 'signpad-hide' : ''">
                        <div class="">
                            <div class="sign-bg">
                                <signature-pad #sigpadFinal [hidden]="hidePad" class="signature-pad" id="signFinal" [options]="signataurePadOptions" (onEndEvent)="signatureFinalOnEnd()" title=""></signature-pad>
                                <div class="canvas-image" [hidden]="!hidePad">
                                    <img *ngIf="imageSrc" [src]="imageSrc">

                                </div>
                                <div>
                                    <div class="display-flex margin-top10" style="align-items:center">
                                        <label for="signatureFinalName" style="text-align:left; min-width:150px;"><b>Enter your Full Name &nbsp;</b></label>
                                        <input style="width:100%" class="form-control" type="text" maxlength="50" id="signatureFinalName" [(ngModel)]="initialFinalSignature" OnlyCharacter (keyup)="initialFinalOnPress($event)" [attr.disabled]="initialFinalDisabled ? '' : null" repHtmlTag />
                                    </div>
                                    <div class="display-flex margin-top10" style="align-items:center">
                                        <button (click)="saveSignature()" class="primary-btn" [disabled]="disable_accept || showSpinner">Accept & Sign <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                                        <button (click)="cMSiteEmployees_Signature_Get()" [disabled]="showSpinner" class="primary-btn">Last Signature <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                                        <button class="primary-btn" (click)="clearSign()" [disabled]="showSpinner" title="Clear Signature">Clear Signature <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="form-group col-sm-3" *ngIf="contractEdit && (contractStatusId <= 3)">
                            <label>Product</label>
                            <kendo-combobox class="form-control min-width300" [data]="productList"
                                            [valuePrimitive]="true"
                                            textField="productName"
                                            [kendoDropDownFilter]="filterSettings"
                                            [clearButton]="false"
                                            [filterable]="true"
                                            (valueChange)="productChange($event, false, true)"
                                            [(ngModel)]="productSelected"
                                            valueField="class4Code"
                                            [disabled]="contractStatusId==6">
                            </kendo-combobox>
                        </div>
                        <div class="form-group col-sm-3" *ngIf="!contractEdit || contractStatusId > 3">
                            <label class="fldtitle" *ngIf="isActionHidden()">Product</label>
                            <label class="fldtitle" *ngIf="!isActionHidden()">Current Product</label>
                            <input name="productSelectedName" [(ngModel)]="productSelectedName" [ngModelOptions]="{standalone: true}" type="text" autocomplete="off" id="productSelectedName" class="form-control" readonly>
                        </div>
                        <div class="form-group col-sm-3" *ngIf="contractEdit && contractStatusId == 0">
                            <label class="fldtitle">Site</label><br>
                            <kendo-combobox class="form-control min-width300" [data]="siteList"
                                            [valuePrimitive]="true"
                                            textField="siteName"
                                            [kendoDropDownFilter]="filterSettings"
                                            [clearButton]="false"
                                            [filterable]="true"
                                            (valueChange)="siteChange($event)"
                                            [(ngModel)]="siteSelected"
                                            valueField="siteID">
                            </kendo-combobox>
                        </div>
                        <div class="form-group col-sm-3" *ngIf="!contractEdit || contractStatusId > 0">
                            <label class="fldtitle">Site</label>
                            <input name="SignupFee" [(ngModel)]="siteSelectedName" [ngModelOptions]="{standalone: true}" type="text" autocomplete="off" id="siteSelectedName" class="form-control" readonly>
                        </div>
                        <div class="form-group col-sm-3">
                            <form [formGroup]="agentForm">
                                <label class="fldtitle">Agent Name</label>
                                <input name="agentName" formControlName="agentName" type="text" autocomplete="off" id="agentName" class="form-control" [readonly]="!hideLabel()">
                            </form>
                        </div>
                        <div class="form-group col-sm-3">
                            <form [formGroup]="contractTypeForm">
                                <label class="fldtitle">Contract Type</label>
                                <input name="contractType" formControlName="contractType" type="text" autocomplete="off" id="contractType" class="form-control" readonly>
                            </form>
                        </div>
                    </div>
                    <div [formGroup]="upgradeForm" class="row upgrade-form" *ngIf="isActionHidden()">
                        <div class="form-group col-sm-2" *ngIf="contractEdit && (contractStatusId == 6)">
                            <label style="color: red; font-weight:bold;">New Product</label>
                            <kendo-combobox class="form-control" [data]="productList"
                                            [valuePrimitive]="true"
                                            textField="productName"
                                            [kendoDropDownFilter]="filterSettings"
                                            [clearButton]="false"
                                            [filterable]="true"
                                            formControlName="upgradeSelected"
                                            (valueChange)="productChange($event, true, true)"
                                            valueField="class4Code">
                            </kendo-combobox>
                        </div>
                        <div class="form-group col-sm-1" *ngIf="contractEdit && contractStatusId == 6">
                            <label>&nbsp;</label>
                            <button (click)="applyNewProduct()" class="primary-btn-small form-control" style="margin-top: -2px;">Apply</button>
                        </div>
                        <div class="form-group col-sm-3">
                            <label class="fldtitle">Already Paid</label>
                            <input name="AlreadyPaid" formControlName="alreadyPaid" type="text" autocomplete="off" id="AlreadyPaid" class="form-control" readonly>
                        </div>
                        <div class="form-group col-sm-3" [hidden]="!upgradeForm.controls['alreadyPaidIsTaxable'].value">
                            <label class="fldtitle">Already Paid Tax</label>
                            <input name="AlreadyPaidTax" formControlName="alreadyPaidTax" type="text" autocomplete="off" id="AlreadyPaidTax" class="form-control" readonly>
                        </div>
                        <div class="form-group col-sm-3">
                            <label class="fldtitle">Paid On</label>
                            <input name="AlreadyPaidOn" formControlName="dtAlreadyPaid" type="text" autocomplete="off" id="AlreadyPaidOn" class="form-control" readonly>
                        </div>
                    </div>
                    <form [formGroup]="siteTaxForm" class="contract-manager">
                        <div formArrayName="fees">
                            <div class="row">
                                <div class="form-group col-sm-3" *ngFor="let fee of siteTaxForm.get('fees')['controls']; let i=index">
                                    <div [formGroupName]="i">
                                        <div>
                                            <!--<label class="fldtitle" [ngClass]="isActionHidden() && contractEdit && fee.value.cmFeeName.indexOf('Membership') > -1 ? 'upgrade-red' : ''">{{fee.value.cmFeeName}}</label>-->
                                            <label class="fldtitle">{{fee.value.cmFeeName}}</label>
                                            <input name="feeAmount" formControlName="feeAmount" type="text" (blur)="onChangeFees(fee,i, false)" autocomplete="off" id="feeAmount" class="form-control" appCurrency [readonly]="readonlyFeeLabel(fee)" [hidden]="isFeeHidden(fee)">
                                            <input name="feeAmount0" type="text" id="feeAmount0" class="form-control" [hidden]="!isZeroFeeHidden(fee, true)" value="Get card on file" readonly>
                                            <input name="feeAmount1" type="text" id="feeAmount1" class="form-control" [hidden]="isZeroFeeHidden(fee, false)" value="No payment required" readonly>
                                        </div>
                                        <div class="fee-tax" [hidden]="!fee.value.isTaxable">
                                            <label class="fldtitle">{{fee.value.cmFeeName}} Tax</label>
                                            <input name="feeTax" formControlName="feeTax" type="text" autocomplete="off" id="feeTax" class="form-control" appCurrency readonly>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-3">
                                <label class="fldtitle">Contract Start</label>
                                <input formControlName="contractStartLabel" type="text" autocomplete="off" class="form-control" [hidden]="hideLabel()" readonly>
                                <mat-form-field [hidden]="!hideLabel()">
                                    <input matInput #ref [matDatepicker]="contractStart" class="form-control" [min]="minDate" (dateChange)="contractStartChange($event)" formControlName="contractStart" id="contractStart">
                                    <mat-datepicker-toggle matSuffix [for]="contractStart"></mat-datepicker-toggle>
                                    <mat-datepicker #contractStart>
                                        <mat-datepicker-actions>
                                            <button mat-button matDatepickerCancel>Cancel</button>
                                            <button mat-button (click)="contractStartSelectToday(contractStart)">Today</button>
                                            <button mat-button="elevated" matDateRangePickerApply>OK</button>
                                        </mat-datepicker-actions>
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group col-sm-3">
                                <label class="fldtitle" [ngClass]="contractTypeID == 3 && actionTypeID == 3 && contractEdit ? 'upgrade-red' : ''">Payment Begins</label>
                                <input formControlName="paymentBeginLabel" type="text" autocomplete="off" class="form-control" [hidden]="hideLabel()" readonly>
                                <mat-form-field [hidden]="!hideLabel()">
                                    <input matInput #ref [matDatepicker]="paymentBegin" class="form-control" [min]="minDate" formControlName="paymentBegin" (dateChange)="contractBeginsChange($event)" id="paymentBegin">
                                    <mat-datepicker-toggle matSuffix [for]="paymentBegin"></mat-datepicker-toggle>
                                    <mat-datepicker #paymentBegin>
                                        <mat-datepicker-actions>
                                            <button mat-button matDatepickerCancel>Cancel</button>
                                            <button mat-button (click)="paymentBeginsSelectToday(paymentBegin)">Today</button>
                                            <button mat-button="elevated" matDatepickerApply>OK</button>
                                        </mat-datepicker-actions>
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group col-sm-3">
                                <form [formGroup]="numPaymentsForm">
                                    <label class="fldtitle" [ngClass]="contractTypeID == 3 && actionTypeID == 3 && contractEdit ? 'upgrade-red' : ''">Number of Payments (Months)</label>
                                    <input name="term" formControlName="term" type="text" autocomplete="off" id="term" class="form-control" mask="00" (change)="changeTermC()" [readonly]="!hideLabel()">
                                </form>
                            </div>
                            <div class="form-group col-sm-3">
                                <label class="fldtitle">Contract Ends (Payment Begins + Term)</label>
                                <input formControlName="contractEndLabel" type="text" autocomplete="off" class="form-control" [hidden]="hideLabel()" readonly>
                                <mat-form-field [hidden]="!hideLabel()">
                                    <input matInput #ref [matDatepicker]="contractEnd" class="form-control" [min]="minDate" formControlName="contractEnd" (dateChange)="contractEndChange($event)" id="contractEnd">
                                    <mat-datepicker-toggle matSuffix [for]="contractEnd"></mat-datepicker-toggle>
                                    <mat-datepicker #contractEnd>
                                        <mat-datepicker-actions>
                                            <button mat-button matDatepickerCancel>Cancel</button>
                                            <button mat-button (click)="contractEndsSelectToday(contractEnd)">Today</button>
                                            <button mat-button="elevated" matDatepickerApply>OK</button>
                                        </mat-datepicker-actions>
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-3">
                                <label class="fldtitle">Contract Expires</label>
                                <input formControlName="contractExpiresLabel" type="text" autocomplete="off" class="form-control" [hidden]="hideLabel()" readonly>
                                <mat-form-field [hidden]="!hideLabel()">
                                    <input matInput #ref [matDatepicker]="contractExpires" class="form-control" [min]="minDate" formControlName="contractExpires" id="contractExpires">
                                    <mat-datepicker-toggle matSuffix [for]="contractExpires"></mat-datepicker-toggle>
                                    <mat-datepicker #contractExpires>
                                        <mat-datepicker-actions>
                                            <button mat-button matDatepickerCancel>Cancel</button>
                                            <button mat-button (click)="contractExpiresSelectToday(contractExpires)">Today</button>
                                            <button mat-button="elevated" matDatepickerApply>OK</button>
                                        </mat-datepicker-actions>
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group col-sm-3">
                                <label class="fldtitle">Contract Signed</label>
                                <input name="ContractSigned" formControlName="dtSignedMembers" type="text" autocomplete="off" id="ContractSigned" class="form-control" readonly>
                            </div>
                            <div class="form-group col-sm-3">
                                <form [formGroup]="termForm">
                                    <label class="fldtitle">Contract Term (Months)</label>
                                    <input name="term" formControlName="term" type="text" autocomplete="off" id="term" class="form-control" mask="00" [readonly]="!hideLabel()">
                                </form>
                            </div>
                            <div class="form-group col-sm-3">
                                <label class="fldtitle">Final Payment</label>
                                <input formControlName="paymentEndLabel" type="text" autocomplete="off" class="form-control" [hidden]="hideLabel()" readonly>
                                <mat-form-field [hidden]="!hideLabel()">
                                    <input matInput #ref [matDatepicker]="paymentEnd" class="form-control" [min]="minDate" formControlName="paymentEnd" id="paymentEnd">
                                    <mat-datepicker-toggle matSuffix [for]="paymentEnd"></mat-datepicker-toggle>
                                    <mat-datepicker #paymentEnd>
                                        <mat-datepicker-actions>
                                            <button mat-button matDatepickerCancel>Cancel</button>
                                            <button mat-button (click)="paymentEndSelectToday(paymentEnd)">Today</button>
                                            <button mat-button="elevated" matDatepickerApply>OK</button>
                                        </mat-datepicker-actions>
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-3" *ngIf="contractId > 0 && api_log_visible && contractStatusId == 6">
                                <label class="fldtitle">RESNET Id</label>
                                <a class="form-control" href="{{resnet_url}}{{siteTaxForm.controls['reservationID'].value}}" target="_blank">{{ siteTaxForm.controls['reservationID'].value }}</a>
                            </div>
                            <div class="form-group col-sm-3" *ngIf="contractId > 0 && api_log_visible && contractStatusId == 6 && contractEdit && siteTaxForm.controls['reservationID'].value == ''">
                                <label class="fldtitle"></label>
                                <button (click)="sendToReservation()" [disabled]="disable_send" class="primary-btn margin-left15" style="display: block;">Send To RESNET</button>
                            </div>
                            <div class="form-group col-sm-3">
                                <form [formGroup]="testModeForm">
                                    <div class="custom-control custom-switch payment-process-check">
                                        <input type="checkbox" class="custom-control-input" id="processorTestMode" formControlName="processorTestMode">
                                        <label class="custom-control-label custom-control-label-disabled" for="processorTestMode">Processor Test Mode</label>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <label class="fldtitle">Product Description<i *ngIf="siteTaxForm.controls['reservationID'].value" class="fa fa-info-circle margin-left15" title="View original contract" (click)="getRESNETContractDescription()" style="font-size:20px; cursor:pointer"></i></label>
                                <div class="rate-sheet-description" [innerHtml]="getProductDescription() | safeHtml"></div>
                            </div>
                        </div>
                        <div class="row" [hidden]="depositSummary?.length == 0">
                            <div class="form-group col-sm-12">
                                <div [innerHtml]="depositSummary | safeHtml"></div>
                            </div>
                        </div>
                        <div class="row" [hidden]="isActionHidden()">
                            <div class="form-group col-sm-12">
                                <label class="fldtitle">Special Terms</label>
                                <textarea name="specialterms" formControlName="specialterms" rows="2" cols="20" maxlength="2000" id="specialterms" class="form-control" [readonly]="!hideLabel()"></textarea>
                            </div>
                        </div>
                        <div class="row row-buffer-top" [hidden]="!isDays || isActionHidden()">
                            <div class="form-group col-sm-12">
                                <label class="fldtitle">Select Days of the Week on Plan</label>
                            </div>
                        </div>
                        <div class="row row-buffer-top" [hidden]="isDays || isActionHidden()">
                            <div class="form-group col-sm-12">
                                <label class="fldtitle">Days of the Week on Plan</label>
                            </div>
                        </div>
                        <div class="row margin-left-none margin-topm10" [hidden]="isActionHidden()">
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isMonday" *ngIf="!hideLabel()" formControlName="isMonday">
                                    <input type="checkbox" class="custom-control-input" [ngClass]="isDays ? '' : 'custom-control-input-disabled'" id="isMonday" formControlName="isMonday" *ngIf="hideLabel()" name="isMonday">
                                    <label class="custom-control-label custom-control-label-disabled" for="isMonday">Mon</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isTuesday" *ngIf="!hideLabel()" formControlName="isTuesday">
                                    <input type="checkbox" class="custom-control-input" [ngClass]="isDays ? '' : 'custom-control-input-disabled'" id="isTuesday" *ngIf="hideLabel()" formControlName="isTuesday">
                                    <label class="custom-control-label custom-control-label-disabled" for="isTuesday">Tues</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isWednesday" *ngIf="!hideLabel()" formControlName="isWednesday">
                                    <input type="checkbox" class="custom-control-input" [ngClass]="isDays ? '' : 'custom-control-input-disabled'" id="isWednesday" *ngIf="hideLabel()" formControlName="isWednesday">
                                    <label class="custom-control-label custom-control-label-disabled" for="isWednesday">Wed</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isThursday" *ngIf="!hideLabel()" formControlName="isThursday">
                                    <input type="checkbox" class="custom-control-input" [ngClass]="isDays ? '' : 'custom-control-input-disabled'" id="isThursday" *ngIf="hideLabel()" formControlName="isThursday">
                                    <label class="custom-control-label custom-control-label-disabled" for="isThursday">Thu</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isFriday" *ngIf="!hideLabel()" formControlName="isFriday">
                                    <input type="checkbox" class="custom-control-input" [ngClass]="isDays ? '' : 'custom-control-input-disabled'" id="isFriday" *ngIf="hideLabel()" formControlName="isFriday">
                                    <label class="custom-control-label custom-control-label-disabled" for="isFriday">Fri</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isSaturday" *ngIf="!hideLabel()" formControlName="isSaturday">
                                    <input type="checkbox" class="custom-control-input" [ngClass]="isDays ? '' : 'custom-control-input-disabled'" id="isSaturday" *ngIf="hideLabel()" formControlName="isSaturday">
                                    <label class="custom-control-label custom-control-label-disabled" for="isSaturday">Sat</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isSunday" *ngIf="!hideLabel()" formControlName="isSunday">
                                    <input type="checkbox" class="custom-control-input" [ngClass]="isDays ? '' : 'custom-control-input-disabled'" id="isSunday" *ngIf="hideLabel()" formControlName="isSunday">
                                    <label class="custom-control-label custom-control-label-disabled" for="isSunday">Sun</label>
                                </div>
                            </div>
                        </div>


                        <div class="row row-buffer-top row-header" [hidden]="isActionHidden()">
                            <div class="col-sm-12">
                                <label>Location Access</label>
                            </div>
                        </div>
                        <div class="row margin-left-none" [hidden]="isActionHidden()">
                            <div class="col-sm-3" *ngFor="let item of siteList;let i=index">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" [disabled]="enabledDisabledLocation(item)" [ngClass]="contractEdit ? '' : 'custom-control-input-disabled'" id="{{item.siteID}}" formControlName="s{{item.siteID}}">
                                    <label class="custom-control-label custom-control-label-disabled" for="{{item.siteID}}">{{item.siteName}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row row-header row-buffer-top" [hidden]="isActionHidden()">
                            <div class="col-sm-12">
                                <label>Boat Classes</label>
                            </div>
                        </div>
                        <div class="row margin-left-none" [hidden]="isActionHidden()">
                            <div class="col-sm-3" *ngFor="let item of cmBoatClasses;let i=index">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" [disabled]="enabledDisabledClass(item)" [ngClass]="contractEdit ? '' : 'custom-control-input-disabled'" id="{{item.classID}}" formControlName="b{{item.classID}}">
                                    <label class="custom-control-label custom-control-label-disabled" for="{{item.classID}}">{{item.class}}</label>
                                </div>
                            </div>
                        </div>



                        <div class="row row-buffer-top" [hidden]="!isSeasonal || isActionHidden()">
                            <div class="form-group col-sm-12">
                                <label class="fldtitle">Select Months on Plan</label>
                            </div>
                        </div>
                        <div class="row margin-left-none margin-topm10" [hidden]="!isSeasonal || isActionHidden()">
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isJanuary" *ngIf="!hideLabel()" formControlName="isJanuary">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isJanuary" formControlName="isJanuary">
                                    <label class="custom-control-label custom-control-label-disabled" for="isJanuary">Jan</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isFebruary" *ngIf="!hideLabel()" formControlName="isFebruary">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isFebruary" formControlName="isFebruary">
                                    <label class="custom-control-label custom-control-label-disabled" for="isFebruary">Feb</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isMarch" *ngIf="!hideLabel()" formControlName="isMarch">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isMarch" formControlName="isMarch">
                                    <label class="custom-control-label custom-control-label-disabled" for="isMarch">Mar</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isApril" *ngIf="!hideLabel()" formControlName="isApril">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isApril" formControlName="isApril">
                                    <label class="custom-control-label custom-control-label-disabled" for="isApril">Apr</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isMay" *ngIf="!hideLabel()" formControlName="isMay">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isMay" formControlName="isMay">
                                    <label class="custom-control-label custom-control-label-disabled" for="isMay">May</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isJune" *ngIf="!hideLabel()" formControlName="isJune">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isJune" formControlName="isJune">
                                    <label class="custom-control-label custom-control-label-disabled" for="isJune">Jun</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isJuly" *ngIf="!hideLabel()" formControlName="isJuly">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isJuly" formControlName="isJuly">
                                    <label class="custom-control-label custom-control-label-disabled" for="isJuly">Jul</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isAugust" *ngIf="!hideLabel()" formControlName="isAugust">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isAugust" formControlName="isAugust">
                                    <label class="custom-control-label custom-control-label-disabled" for="isAugust">Aug</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isSeptember" *ngIf="!hideLabel()" formControlName="isSeptember">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isSeptember" formControlName="isSeptember">
                                    <label class="custom-control-label custom-control-label-disabled" for="isSeptember">Sep</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isOctober" *ngIf="!hideLabel()" formControlName="isOctober">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isOctober" formControlName="isOctober">
                                    <label class="custom-control-label custom-control-label-disabled" for="isOctober">Oct</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isNovember" *ngIf="!hideLabel()" formControlName="isNovember">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isNovember" formControlName="isNovember">
                                    <label class="custom-control-label custom-control-label-disabled" for="isNovember">Nov</label>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isDecember" *ngIf="!hideLabel()" formControlName="isDecember">
                                    <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isDecember" formControlName="isDecember">
                                    <label class="custom-control-label custom-control-label-disabled" for="isDecember">Dec</label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="payment-method-contract" [hidden]="isActionHidden()">
                    <mat-accordion class="payment-method-panel">
                        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                            <mat-expansion-panel-header>
                                <mat-panel-title> Accepted Payment Methods </mat-panel-title>
                                <mat-panel-description>
                                    <div><mat-icon>payments</mat-icon></div>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <form [formGroup]="paymentForm">
                                <div class="payment-grid">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Non-Recurring Fees</th>
                                                <th>Recurring Fees</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Credit Card</td>
                                                <td>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isEntryCC" *ngIf="!hideLabel()" formControlName="isEntryCC">
                                                        <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isEntryCC" formControlName="isEntryCC">
                                                        <label class="custom-control-label custom-control-label-disabled" for="isEntryCC"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isMonthlyCC" *ngIf="!hideLabel()" formControlName="isMonthlyCC">
                                                        <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isMonthlyCC" formControlName="isMonthlyCC">
                                                        <label class="custom-control-label custom-control-label-disabled" for="isMonthlyCC"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>ACH</td>
                                                <td>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isEntryACH" *ngIf="!hideLabel()" formControlName="isEntryACH">
                                                        <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isEntryACH" formControlName="isEntryACH">
                                                        <label class="custom-control-label custom-control-label-disabled" for="isEntryACH"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isMonthlyACH" *ngIf="!hideLabel()" formControlName="isMonthlyACH">
                                                        <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isMonthlyACH" formControlName="isMonthlyACH">
                                                        <label class="custom-control-label custom-control-label-disabled" for="isMonthlyACH"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Physical Check</td>
                                                <td>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isEntryCheck" *ngIf="!hideLabel()" formControlName="isEntryCheck">
                                                        <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isEntryCheck" formControlName="isEntryCheck">
                                                        <label class="custom-control-label custom-control-label-disabled" for="isEntryCheck"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isMonthlyCheck" *ngIf="!hideLabel()" formControlName="isMonthlyCheck">
                                                        <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isMonthlyCheck" formControlName="isMonthlyCheck">
                                                        <label class="custom-control-label custom-control-label-disabled" for="isMonthlyCheck"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Cash</td>
                                                <td>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" onclick="return false" class="custom-control-input custom-control-input-disabled" id="isEntryCash" *ngIf="!hideLabel()" formControlName="isEntryCash">
                                                        <input type="checkbox" *ngIf="hideLabel()" class="custom-control-input" id="isEntryCash" formControlName="isEntryCash">
                                                        <label class="custom-control-label custom-control-label-disabled" for="isEntryCash"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
        </div>

        <div class="new-member" [hidden]="isActionHidden()">
            <div class="common-header contract-header" [hidden]="!hideAddMemberLabel() || !checkMaxMem()">
                <div class="text-left width-50 float-left"></div>
                <div class="text-right width-50 float-right">
                    <div class="button-group">
                        <button class="primary-btn" [hidden]="disableSaveContract" (click)="openContact(true)">Add Member <i class="fa fa-plus"></i></button>
                    </div>
                </div>
            </div>
            <hr style="border-top: transparent;" />
            <div class="new-member-section">
                <div class="new-member-panel text-right"><span [hidden]="feeButtonList?.length == 0 || contacts?.length == 1">Split Evenly:</span></div>
                <div class="new-member-panel text-center">
                    <div class="split-btn-panel" *ngFor="let f of feeButtonList; let bi=index;">
                        <button class="btn edit-btn" [disabled]="hideSplit(f)" (click)="setEvenly(f)" *ngIf="contacts?.length > 1">{{f.cMFeeName}}</button>
                    </div>
                </div>
                <div class="new-member-panel"></div>
            </div>
            <div [formGroup]="membersForm">
                <div formArrayName="members">
                    <div class="new-member-section" *ngFor="let mem of membersForm.get('members')['controls']; let i=index" [formGroupName]="i">
                        <div class="new-member-panel">
                            <h6><b><a href="{{mySoLink}}/contact/{{mem.get('contactId')?.value}}" target="_blank">{{ mem.get('firstName')?.value}} {{mem.get('lastName')?.value}}</a></b></h6>
                            <div class="address-panel">
                                <p *ngIf="mem.get('add1')?.value">{{ mem.get('add1')?.value}}</p>
                                <p *ngIf="mem.get('city')?.value && mem.get('state')?.value && mem.get('zip')?.value">
                                    <span *ngIf="mem.get('city')?.value">{{mem.get('city')?.value}},</span>
                                    <span *ngIf="mem.get('state')?.value">{{mem.get('state')?.value}} </span>
                                    <span *ngIf="mem.get('zip')?.value">{{mem.get('zip')?.value}}</span>
                                </p>
                                <p><b>E:</b> {{mem.get('email')?.value}}</p>
                                <p><b>P:</b> {{mem.get('mobile')?.value | phoneFormat}}</p>
                                <p><b>{{mem.get('isPrimary')?.value ? 'Primary Member' : mem.get('relationship')?.value}}</b></p>
                                <p *ngIf="mem.get('relationship')?.value == 'Other'"><b>{{mem.get('explain')?.value}}</b></p>
                            </div>
                        </div>
                        <div class="new-member-fee-panel">
                            <div formArrayName="memberFees">
                                <div class="contract-product-panel">
                                    <div class="" *ngFor="let fee of mem?.get('memberFees')['controls']; let j=index">
                                        <div class="contract-product-fee" [formGroupName]="j">
                                            <div class="form-group">
                                                <label>{{fee.get('cMFeeName')?.value}}</label>
                                                <input class="form-control" formControlName="feeBase" type="text" appCurrency (change)="feeChange(fee)" [readonly]="isFeeBaseReadOnly(mem, fee)" [hidden]="isFeeHidden(fee)" />
                                                <input class="form-control" type="text" value="Get card on file" readonly [hidden]="!isZeroFeeHidden(fee, true)" />
                                                <input class="form-control" type="text" value="No payment required" readonly [hidden]="isZeroFeeHidden(fee, false)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="new-member-panel">
                            <div class="action-btn">
                                <i class="fa fa-pencil" [hidden]="!hideLabel()" (click)="openContactForm(mem.get('contactId')?.value, mem.get('isPrimary')?.value)"></i>
                                <i class="fa fa-trash" [hidden]="!hideLabel()" *ngIf="mem.get('isPrimary')?.value == false && mem.get('statusId')?.value < 6 " (click)="confirmMemberDlt(mem.get('cMMemberID')?.value,mem.get('contactId')?.value, i)"></i>
                            </div>
                            <p>

                                Status:
                                <span [ngClass]="getStatus(mem.get('statusId')?.value) == 'Active' ? 'comp-text-complete' : 'comp-text'">
                                    {{getStatus(mem.get('statusId')?.value)}}
                                </span>
                            </p>
                            <button class="primary-btn margin-left15 manage-button"
                                    [disabled]="mem.get('cMMemberID')?.value == 0 || !!memberMissingContactInfo(mem)"
                                    [title]="memberMissingContactInfo(mem) || ''"
                                    (click)="sendMemberText(mem.get('contactId')?.value, i, mem.get('firstName')?.value + ' ' + mem.get('lastName')?.value)">Send Contract</button>
                            <button class="primary-btn margin-left15 manage-button"
                                    [disabled]="mem.get('cMMemberID')?.value == 0 || !!memberMissingContactInfo(mem)"
                                    [title]="memberMissingContactInfo(mem) || ''"
                                    (click)="redirctf2f(mem.get('contactId')?.value, mem.get('firstName')?.value + ' ' + mem.get('lastName')?.value)">Face to Face</button>
                            <div [hidden]="user?.slurpyUserId == 0 || contractId == 0 || !admin_override || !hideLabel()" class="admin-statuses">
                                <kendo-combobox class="form-control min-width200" [data]="memberStatuses"
                                                [valuePrimitive]="true"
                                                textField="status"
                                                [kendoDropDownFilter]="filterSettings"
                                                [clearButton]="false"
                                                [filterable]="true"
                                                formControlName="statusIdAdmin"
                                                valueField="statusID">
                                </kendo-combobox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button [hidden]="!contractEdit" type="submit" class="primary-btn" [ngClass]="isActionHidden() ? 'upgrade-save' : ''" (click)="saveContract(null)">Save Contract <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
    </div>
</div>
<div id="contactModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{isEditMem ? 'Edit Member' : 'Add Member'}} </h4>
                <button type="button" class="close" (click)="hideModalContact()">&times;</button>
            </div>
            <div class="modal-body">
                <div class="edit-panel" style="padding-left:0px;">
                    <div class="edit-colunm full-width">
                        <div class="row row-extended">
                            <div class="col-md-6">
                                <div class="display-flex" *ngIf="!isEditMem">
                                    <div class="display-flex">
                                        <kendo-autocomplete #autocomplete class="auto-width" [data]="searchList" valueField="searchText" placeholder="Search" (valueChange)="goToLink($event)"
                                                            (keydown.enter)="goToLink($event)" (keyup)="getSearchData($event.target.value)" style="min-height:40px;"></kendo-autocomplete>
                                    </div>
                                    <button class="primary-btn margin-left15" (click)="contactHide()">Create Contact <i class="fa fa-plus"></i></button>
                                </div>
                            </div>
                        </div>
                        <div [hidden]="!isContactCreate">
                            <form [formGroup]="contactForm">
                                <div class="row row-extended" style="margin-top:20px;">
                                    <div class="col-sm-3">
                                        <label class="fldtitle">First Name<span style="color:red">*</span></label>
                                        <input type="text" name="txtFirstName" formControlName="txtFirstName" autocomplete="off" id="txtFirstName" class="form-control">
                                        <div *ngIf="contactForm.controls.txtFirstName.errors && (contactForm.controls.txtFirstName.touched || contactForm.controls.txtFirstName.dirty)">
                                            <div class="login-error" *ngIf="contactForm.controls.txtFirstName.errors.required">First name is required. </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Last Name<span style="color:red">*</span></label>
                                        <input type="text" name="txtLastName" formControlName="txtLastName" autocomplete="off" id="txtLastName" class="form-control">
                                        <div *ngIf="contactForm.controls.txtLastName.errors && (contactForm.controls.txtLastName.touched || contactForm.controls.txtLastName.dirty)">
                                            <div class="login-error" *ngIf="contactForm.controls.txtLastName.errors.required">Last name is required. </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="fldtitle">Email<span style="color:red">*</span></label>
                                        <input type="text" name="txtEmail" formControlName="txtEmail" autocomplete="off" id="txtEmail" class="form-control">
                                        <div *ngIf="contactForm.controls.txtEmail.errors && (contactForm.controls.txtEmail.touched || contactForm.controls.txtEmail.dirty)">
                                            <div class="login-error" *ngIf="contactForm.controls.txtEmail.errors.required">Email is required. </div>
                                            <div class="login-error" *ngIf="contactForm.controls.txtEmail.errors.pattern">Invalid Email</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row row-extended" style="margin-top:20px;">
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Mobile<span style="color:red">*</span></label>
                                        <input type="text" name="txtMobilePhone" formControlName="txtMobilePhone" autocomplete="off" id="txtMobilePhone" class="form-control" [placeholder]="placeHolder" [mask]="mobile_mask">
                                        <div *ngIf="contactForm.controls.txtMobilePhone.errors && (contactForm.controls.txtMobilePhone.touched || contactForm.controls.txtMobilePhone.dirty)">
                                            <div class="login-error" *ngIf="contactForm.controls.txtMobilePhone.errors.required">Mobile number is required. </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Home Phone</label>
                                        <input type="text" name="txtHomePhone" formControlName="txtHomePhone" [mask]="mobile_mask" autocomplete="off" id="txtHomePhone" class="form-control">
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="fldtitle">Address</label>
                                        <input type="text" name="txtAddress" formControlName="txtAddress" autocomplete="off" value="Add 1" id="txtAddress" class="form-control">
                                    </div>
                                </div>
                                <div class="row row-extended" style="margin-top:20px;">
                                    <div class="col-sm-3">
                                        <label class="fldtitle">City</label>
                                        <input type="text" name="txtCity" formControlName="txtCity" autocomplete="off" value="NEW YORK" id="txtCity" class="form-control">
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Zip</label>
                                        <input type="text" name="txtZip" formControlName="txtZip" minLength="3" maxLength="7" autocomplete="off" value="247001" id="ContentPlaceHolder1_txtZip" class="form-control">
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Country</label>
                                        <kendo-combobox [data]="countryDD"
                                                        class="form-control min-width200"
                                                        [valuePrimitive]="true"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        textField="country_Name"
                                                        formControlName="country"
                                                        valueField="country_Code"
                                                        (valueChange)="onChangeCountry($event)">
                                        </kendo-combobox>
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="fldtitle">State</label>
                                        <kendo-combobox [data]="stateList"
                                                        class="form-control min-width200"
                                                        [valuePrimitive]="true"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        formControlName="state"
                                                        textField="text"
                                                        valueField="value">
                                        </kendo-combobox>
                                    </div>
                                </div>
                            </form>

                            <form [formGroup]="contactForm2">
                                <div class="row row-extended" style="margin-top:20px;">
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Driver's License</label>
                                        <input type="text" name="dl" formControlName="dl" autocomplete="off" id="dl" class="form-control">
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Date of Birth</label>
                                        <!--<kendo-datepicker formControlName="dob" [format]="format"></kendo-datepicker>-->
                                        <input type="text" name="dl" formControlName="dob" autocomplete="off" id="dob" class="form-control">
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Emergency Contact Name</label>
                                        <input type="text" name="emgContactName" formControlName="emgContactName" autocomplete="off" id="emgContactName" class="form-control">
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="fldtitle">Emergency Contact Phone</label>
                                        <input type="text" name="txtEmgCntPhone" [mask]="mobile_mask" (keypress)="validateNumber($event)" formControlName="txtEmgCntPhone" autocomplete="off" id="txtEmgCntPhone" class="form-control">
                                    </div>
                                </div>
                                <div class="row row-extended" style="margin-top:20px;">
                                    <div class="col-sm-6">
                                        <label class="fldtitle">Site</label>
                                        <input name="site" formControlName="site" type="text" autocomplete="off" id="siteSelectedName" class="form-control" readonly>
                                    </div>
                                    <div class="col-sm-3" *ngIf="contactForm2.controls['isPrimary'].value == false">
                                        <label class="fldtitle">Relationship to Primary Member</label>
                                        <kendo-combobox [data]="relationshipStatus"
                                                        class="form-control min-width200"
                                                        [valuePrimitive]="true"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        formControlName="relationshipID"
                                                        textField="status"
                                                        valueField="statusID">
                                        </kendo-combobox>
                                    </div>
                                    <div class="col-sm-3" *ngIf="contactForm2.controls['relationshipID'].value == 6">
                                        <label class="fldtitle">Explain</label>
                                        <input name="site" formControlName="explain" type="text" autocomplete="off" id="explain" class="form-control">
                                    </div>
                                </div>
                                <div class="row row-extended" style="margin-top:20px;">
                                    <div class="col-sm-6">
                                    </div>
                                    <div class="col-sm-6 text-right">
                                        <button class="primary-btn" type="button" *ngIf="contactId != fromContactId" (click)="importPrimary()">Import Primary Member Info</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="form-group center">
                    <button class="btn primary-btn" type="submit" (click)="saveContact()" [disabled]="saveContactValid()">Save <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                    <button class="btn secondary-btn" type="button" (click)="hideModalContact()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Delete Member Modal-->
<div id="deleteMemberConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">Are you sure you want to delete this member?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" (click)="memberDelete()">Confirm</button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Delete Product Modal-->
<div id="deleteContractConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">Are you sure you want to delete this contract?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" [disabled]="showSpinner" (click)="deleteContract()">Confirm  <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Text Modal-->
<div id="textConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <!-- Modal content-->
        <div class="modal-content">
            <form class="form-horizontal" [formGroup]="textForm">
                <div class="modal-header">
                    <h5 class="modal-title">Send a Text Message</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="margin-top10">
                    <div class="form-group col-sm-12">
                        <label class="control-label" for="txtMsg">Text Message <span style="color:green">(max 500 chars)</span></label>
                        <div>
                            <textarea type="text" rows="5" formControlName="txtMsg" class="form-control" maxlength="500"></textarea>
                        </div>
                    </div>
                </div>
                <div class="margin-top10">
                    <div class="form-group col-sm-12">
                        <label class="control-label" for="mediaURL">Media URL</label>
                        <div>
                            <input formControlName="mediaURL" class="form-control" maxlength="300" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="sendEmail" formControlName="sendEmail" name="sendEmail">
                        <label class="custom-control-label custom-control-label-disabled" for="sendEmail">Send Email</label>
                    </div>
                    <button type="submit" class="btn btn-success" (click)="sendText()">Send</button>
                    <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div id="unEqualPayConfirmModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">It looks like you've changed the Fees for the Product. Are you sure you want to save this contract?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" [disabled]="showSpinner" (click)="saveContract(null, true)">Confirm  <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Upgrade Contract Modal-->
<div id="upgradeContractConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">Changing this contract will archive the current contract, delete all current subscriptions, and use any payment made as already paid. Are you sure you want to change this contract?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" [disabled]="showSpinner" (click)="upgradeContract()">Confirm  <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Renew Contract Modal-->
<div id="renewContractConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">Renewing this contract will archive the current contract, delete all current subscriptions and use any payment made as already paid. Are you sure you want to renew to this contract?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" [disabled]="showSpinner" (click)="renewContract()">Confirm  <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Add Paying Member Contract Modal-->
<div id="addPMContractConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">Adding a {{paying}}Member will archive the current contract, delete all current subscriptions and use any payment made as already paid. Are you sure you want to add a {{paying}}member to this contract?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" [disabled]="showSpinner" (click)="addPMContract()">Confirm  <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Change Plan Contract Modal-->
<div id="changePlanConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">Changing the Plan of this contract will reset all signed documents and payment setups for this contract. Are you sure you want to change the plan?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" [disabled]="showSpinner" (click)="changePlan()">Confirm  <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Terminate Plan Contract Modal-->
<div id="terminatePlanConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">Terminating this contract will archive the current contract and delete all current subscriptions. No payments will be carried forward. Are you sure you want to terminate the plan?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" [disabled]="showSpinner" (click)="terminatePlan()">Confirm  <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- RESNET Contract Modal-->
<div id="resnetContractModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">RESNET Contract</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="rate-sheet-description" [innerHtml]="resnet_contract | safeHtml"></div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Change Contract Modal-->
<div id="changeContractConfirmation" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <h6 class="modal-title">A Payment has been made towards this Contract. Changing this contract will archive the current contract and use any payment made as already paid. Are you sure you want to change this contract?</h6>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success" [disabled]="showSpinner" (click)="changeContract()">Confirm  <i *ngIf="showSpinner" class="fa fa-spinner fa-spin"></i></button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

